module.exports = __webpack_public_path__ + "static/wabi-sabi-2a124ebcea37688e214110ad375fd9b2.png";